import { format, isToday, isSameDay } from "date-fns";
function classNames(...classes) {return classes.filter(Boolean).join(' ')}

const LargeWeekView = ({displayedWeek, selectedDay}) => {

    return (
        <div className="-mr-px hidden grid-cols-7 divide-x divide-gray-100 border-r z-1000 border-gray-100 text-sm leading-6 text-gray-500 sm:grid">
          <div className="col-end-1 w-14" />
          {displayedWeek.map((date, index) => (
            <div key={index} className="flex items-center justify-center py-3">
              <span>
                {format(date, 'EEE')} <span className={classNames(isToday(date) && 'py-0 px-2 rounded-full bg-indigo-600 text-white', (isSameDay(date, selectedDay.date) && !isToday(date)) && 'text-indigo-500 border-solid border rounded-full py-0 px-1' ,"items-center justify-center font-semibold text-gray-900")}>{format(date, 'd')}</span>
              </span>
            </div>
          ))}
        </div>
    )
}
export default LargeWeekView;